"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Activity, Zap, Heart, Briefcase, ArrowRight } from "lucide-react";
export default function OurServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    title: "Sports Physiotherapy",
    description: "Expert treatment for sports injuries, performance optimization, and injury prevention for active individuals.",
    icon: Activity,
    link: "/ServicesPage"
  }, {
    title: "Back & Neck Pain",
    description: "Evidence-based relief for chronic and acute back and neck pain, tailored to your specific condition.",
    icon: Zap,
    link: "/ServicesPage"
  }, {
    title: "Post-Operative Rehabilitation",
    description: "Comprehensive recovery programs designed to restore function and mobility after surgery.",
    icon: Heart,
    link: "/ServicesPage"
  }, {
    title: "Workplace & Posture Injuries",
    description: "Targeted treatment for office-related pain and posture issues to improve daily comfort and productivity.",
    icon: Briefcase,
    link: "/ServicesPage"
  }];
  const refs = [ref1, ref2, ref3, ref4];
  const visibilityStates = [isVisible1, isVisible2, isVisible3, isVisible4];
  return <section id="our-services" className="py-24 bg-background">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-foreground mb-4">Our Services</h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Personalized, evidence-based physiotherapy to help you recover, perform, and thrive.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-300 ease-spring ${visibilityStates[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full group bg-[#FA8E8E] hover:shadow-strong hover:-translate-y-2 transition-all duration-300 ease-spring border-2 border-transparent hover:border-primary">
                  <CardHeader>
                    <div className="mb-4">
                      <Icon className="w-12 h-12 text-secondary stroke-[1.5]" />
                    </div>
                    <CardTitle className="text-foreground text-xl mb-2">
                      {service.title}
                    </CardTitle>
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <Link to={service.link} className="inline-flex items-center gap-2 text-foreground font-semibold hover:gap-3 transition-all duration-150 ease-out group-hover:translate-x-1">
                      Learn More
                      <ArrowRight className="w-4 h-4" />
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}